import { Injectable } from '@angular/core';
import { MainMenu, MenuAdmin } from 'app/shared/models/class/menu/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  /* ------------------------------- Admin menu ------------------------------- */

  /* -------------------------------------------------------------------------- */

  // roles = ['admin', 'AdminCROS', 'AdminMSR', 'AdminSITE'];

  menu: MenuAdmin[] = [
    {
      name: 'Les articles',
      description: 'Gérer l\'ensemble des articles',
      icon: 'faNewspaper',
      iconLabel: 'faNewspaper',
      // icon: '/assets/img/newspaper-solid.svg',
      // iconLabel: '/assets/img/newspaper-solid.svg',
      url: '/admin/articles',
      iconType: 'faicon',
      role: ['admin', 'AdminCROS', 'AdminMSR', 'AdminSITE']
    },
    {
      name: 'Les acteurs',
      description: 'Gérer l\'ensemble des acteurs',
      // icon: '/assets/img/clubs.svg',
      // iconLabel: '/assets/img/clubs.svg',
      icon: 'faUsers',
      iconLabel: 'faUsers',
      url: '/admin/actors',
      // url: '/admin/clubs',
      // iconType: 'club',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Les utilisateurs',
      description: 'Gérer l\'ensemble des utilisateurs',
      icon: 'faUsers',
      iconLabel: 'faUsers',
      url: '/admin/users',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE', 'AdminCROS']
    },
    {
      name: 'Les structures',
      description: 'Gérer l\'ensemble des structures',
      icon: 'faSitemap',
      iconLabel: 'faSitemap',
      url: '/admin/structure',
      iconType: 'faicon',
      role: ['admin']
    },
    {
      name: 'Tableau de bord de l\'acteur',
      description: 'Éditer les infos de mon acteur',
      // icon: '/assets/img/clubs.svg',
      // iconLabel: '/assets/img/clubs.svg',
      icon: 'faUsers',
      iconLabel: 'faUsers',
      url: '/admin/my-club',
      // iconType: 'club',
      iconType: 'faicon',
      role: ['AdminSITE', 'AdminCROS']
    },
    // {
    //   name: 'Guichet',
    //   description: 'Afficher le guichet virtuel du club',
    //   icon: 'faCashRegister',
    //   iconLabel: 'faCashRegister',
    //   url: '/admin/counter',
    //   iconType: 'faicon',
    //   role: ['club', 'admin', 'counter']
    // },
    // {
    //   name: 'Planification',
    //   description: 'Gérer la planification des sessions',
    //   icon: 'faCalendarAlt',
    //   iconLabel: 'faCalendarAlt',
    //   url: '/admin/planning',
    //   iconType: 'faicon',
    //   role: ['club', 'admin', 'planning']
    // },
    // {
    //   name: 'Paiements',
    //   description: 'Gérer les paiements du site',
    //   icon: 'faCreditCard',
    //   iconLabel: 'faCreditCard',
    //   url: '/admin/payments',
    //   iconType: 'faicon',
    //   role: ['club', 'admin']
    // },
    // {
    //   name: 'Disciplines',
    //   description: 'Gérer les disciplines',
    //   // icon: 'faMapMarkerAlt',
    //   // iconLabel: 'faMapMarkerAlt',
    //   icon: 'faMedal',
    //   iconLabel: 'faMedal',
    //   url: '/admin/disciplines',
    //   iconType: 'faicon',
    //   role: ['club', 'admin']
    // },
    {
      name: 'Priorités des articles',
      description: 'Gérer la priorité des articles',
      icon: 'faStar',
      iconLabel: 'faStar',
      url: '/admin/offer-priority',
      iconType: 'faicon',
      role: ['AdminSITE', 'admin', 'AdminCROS', 'AdminMSR']
    },
    // {
    //   name: 'Priorités des offres',
    //   description: 'Gérer la priorité des offres',
    //   icon: 'faStar',
    //   iconLabel: 'faStar',
    //   url: '/admin/offer-priority',
    //   iconType: 'faicon',
    //   role: ['club', 'admin']
    // },
    // {
    //   name: 'Code Promo',
    //   description: 'Gérer les codes promo du club',
    //   icon: 'faPercentage',
    //   iconLabel: 'faTags',
    //   url: '/admin/discount',
    //   iconType: 'faicon',
    //   role: ['club', 'admin']
    // },
    // {
    //   name: 'Ressources du club',
    //   description: 'Gérer les ressources moniteur du club',
    //   icon: 'faUsers',
    //   iconLabel: 'faUsers',
    //   url: '/admin/resource',
    //   iconType: 'faicon',
    //   role: ['club', 'admin']
    // },
    {
      name: 'Tags',
      description: 'Gérer les tags des articles',
      icon: 'faTags',
      iconLabel: 'faTags',
      url: '/admin/tags',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE']
    },
    // {
    //   name: 'Utilisations des ressources',
    //   description: 'Liste des ressources utilisées dans des sessions',
    //   icon: 'faTable',
    //   iconLabel: 'faTable',
    //   url: '/admin/used-ressources',
    //   iconType: 'faicon',
    //   role: ['admin', 'club']
    // },
    {
      name: 'Articles',
      description: 'Exporter les articles en fichier Excel',
      icon: 'faFileExcel',
      iconLabel: 'faFileExcel',
      url: '/admin/',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE', 'AdminCROS']
    },
    {
      name: 'Liste des modifications',
      description: 'Historique des modifications sur les sessions',
      icon: 'faBookOpen',
      iconLabel: 'faBookOpen',
      url: '/admin/modifications',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE', 'AdminCROS', 'AdminMSR']
    },
    // {
    //   name: 'Paramètres',
    //   description: 'Gérer les paramètres globaux',
    //   icon: 'faPen',
    //   iconLabel: 'faPen',
    //   url: '/admin/parameters',
    //   iconType: 'faicon',
    //   role: ['admin']
    // },
    // {
    //   name: 'Sessions',
    //   description: 'Recherche de sessions',
    //   icon: 'faListAlt',
    //   iconLabel: 'faListAlt',
    //   url: '/admin/sessions',
    //   iconType: 'faicon',
    //   role: ['admin', 'club']
    // },
    // {
    //   name: 'Fédérations',
    //   description: 'Fédérations et licences',
    //   icon: 'faPassport',
    //   iconLabel: 'faPassport',
    //   url: '/admin/federations',
    //   iconType: 'faicon',
    //   role: ['admin']
    // },
    {
      name: 'Extractions',
      description: 'Extractions d\'excels des différentes tables',
      icon: 'faArrowAltCircleUp',
      iconLabel: 'faArrowAltCircleUp',
      url: '/admin/reports',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE', 'AdminCROS', 'AdminMSR']
    },
    {
      name: 'Les annonces',
      description: `Gérer l'ensemble des annonces`,
      icon: 'faBullhorn',
      iconLabel: 'faBullhorn',
      url: '/admin/announces',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE']
    },
    {
      name: 'Les formulaires',
      description: `Gérer l'ensemble des formulaires`,
      icon: 'faFile',
      iconLabel: 'faFile',
      url: '/admin/forms',
      iconType: 'faicon',
      role: ['admin', 'AdminSITE', 'AdminCROS', 'AdminMSR']
    },
    // {
    //   name: 'Aides vidéos',
    //   description: 'Gérer les aides vidéos',
    //   icon: 'faVideo',
    //   iconLabel: 'faVideo',
    //   url: '/admin/help',
    //   iconType: 'faicon',
    //   role: ['admin']
    // }
  ];



  mainMenu: MainMenu[] = [
    {
      name: 'Trouvez un article',
      url: '/home',
      faIcon: 'faSearch'
    },
    {
      name: 'Mes favoris',
      url: '/home/my-shopping-bag',
      faIcon: 'faShoppingBasket'
    }
    // {
    //   name: 'Mes favoris',
    //   url: '/home/my-wishes',
    //   faIcon: faHeart
    // },
    // {
    //   name: 'Mes réservations',
    //   url: '/home/purchases-history',
    //   faIcon: 'faBookmark'
    // },
    // {
    //   name: 'Mon panier - Mes favoris',
    //   url: '/home/my-shopping-bag',
    //   faIcon: 'faShoppingBasket'
    // }
  ];

  navSession: string[] = ['Toutes les sessions', 'Sessions du mois'];

  constructor() { }
}
